/**
 * Shared SIPS score formatting used by dashboard and notifications.
 * Numerator = on-time successful intakes; denominator = intervals elapsed today.
 */
export interface SipsScoreTracking {
  successfulIntakes?: number | null;
  reminderCount?: number | null;
}

export function formatDynamicScore(tracking: SipsScoreTracking): string {
  const numerator = tracking.successfulIntakes ?? 0;
  const denominator = Math.max(tracking.reminderCount ?? 0, 1);
  return `${numerator}/${denominator}`;
}

export function getDynamicScoreParts(tracking: SipsScoreTracking): {
  numerator: number;
  denominator: number;
} {
  const numerator = tracking.successfulIntakes ?? 0;
  const denominator = Math.max(tracking.reminderCount ?? 0, 1);
  return { numerator, denominator };
}

/** Debounce window for duplicate notification/API double-fires (not real re-logs). */
export const RAPID_DUPLICATE_LOG_MS = 3000;

export function isRapidDuplicateLog(
  tracking: SipsScoreTracking & { updatedAt?: Date | string | null },
  now: Date = new Date()
): boolean {
  if (!tracking.updatedAt || (tracking.successfulIntakes ?? 0) === 0) {
    return false;
  }

  const lastUpdated = new Date(tracking.updatedAt);
  if (Number.isNaN(lastUpdated.getTime())) {
    return false;
  }

  return now.getTime() - lastUpdated.getTime() < RAPID_DUPLICATE_LOG_MS;
}
